import React from "react";

import { Props } from "./types";
import { RemoveIcon } from "./removeIcon";
import styles from "./styles.scss";

function Tag({ tag, remove }: Props) {
  return (
    <div className={styles.tag}>
      <p>{tag.name}</p>
      <div
        className={styles.removeTagIconContainer}
        onClick={() => remove(tag)}
      >
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Tag };
